import * as React from 'react';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import AdditiveCategoryService from "../../services/AdditiveCategories.service";
import { CustomInput } from "../../components/CustomComponents"
import { useTranslation } from "react-i18next";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import LanguagesService from "../../services/Languages.service";
import { avaiableLangList } from '../../i18nextConf'

export default function AdditiveCategoryEdit(props) {

    const { t } = useTranslation();
    const isAdmin = props.isAdmin;

    const [loading, setLoading] = React.useState(true);
    const [languages, setLanguages] = React.useState([]);
    const [newResource, setNewResource] = React.useState(false);
    const [selectedLenguage, setSelectedLenguage] = React.useState({ name: "Loading...", languageId: "" });

    const [additiveCategory, setAdditiveCategory] = React.useState({
        "additiveCategoryId": "",
        "name": ""
    });


    React.useEffect(() => {

        LanguagesService.getLanguages()
            .then(response => response.data.contract)
            .then(json => {
                setLanguages(json);
                var selected = localStorage.getItem("i18nextLng") || "en";
                var selectedLangDetails = avaiableLangList.find(lang => lang.short === selected);
                var defaultLang = json.find(lang => lang.languageId === selectedLangDetails.id);
                setSelectedLenguage(defaultLang);
            });

    }, []);

    React.useEffect(() => {

        if (props.additiveCategoryId)
            AdditiveCategoryService.getAdditiveCategory(props.additiveCategoryId, selectedLenguage.languageId)
                .then(response => response.data.contract)
                .then(json => {
                    setAdditiveCategory({
                        "additiveCategoryId": props.additiveCategoryId,
                        "name": json.name
                    });
                    setLoading(false);
                })
                .catch(error => {
                    setAdditiveCategory({
                        "additiveCategoryId": props.additiveCategoryId,
                        "name": ""
                    });
                    setNewResource(true);
                    setLoading(false);
                });
    }, [props.additiveCategoryId, selectedLenguage]);

    const handleSubmit = (dataItem) => {

        if (newResource) {
            AdditiveCategoryService.createLocalization({
                "additiveCategoryId": parseInt(dataItem.additiveCategoryId),
                "languageId": selectedLenguage.languageId,
                "name": dataItem.name
            });
        }
        else {
            AdditiveCategoryService.updateLocalization({
                "additiveCategoryId": parseInt(dataItem.additiveCategoryId),
                "languageId": selectedLenguage.languageId,
                "name": dataItem.name
            });
        }
        setAdditiveCategory(dataItem);

    }

    return (
        <div>
            <Form
                onSubmit={handleSubmit}
                initialValues={additiveCategory}
                key={JSON.stringify(additiveCategory)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">

                                    <b>{t("AdditiveCategories_Details_GeneralData_Title")}</b>

                                    <DropDownList
                                        label={t("Global_Label_Text_Language")}
                                        name="language"
                                        loading={loading}
                                        textField="name"
                                        value={selectedLenguage}
                                        dataItemKey="languageId"
                                        style={{ width: '200px' }}
                                        onChange={e => setSelectedLenguage(e.value)}
                                        data={languages}
                                    />

                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <Field
                                                label={t("AdditiveCategories_ID_Label")}
                                                name={'additiveCategoryId'}
                                                disabled={true}
                                                loading={loading}
                                                component={CustomInput}
                                                onChange={e => setAdditiveCategory({ ...additiveCategory, name: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-sm-9">
                                            <Field
                                                label={t("AdditiveCategories_Name_Label")}
                                                name={'name'}
                                                disabled={!isAdmin}
                                                loading={loading}
                                                component={CustomInput}
                                                //validator={[requiredValidator]}
                                                onChange={e => setAdditiveCategory({ ...additiveCategory, name: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <br />
                        {isAdmin ? (<div className="float-sm-right k-form-buttons">
                            <button
                                type={'submit'}
                                disabled={!formRenderProps.allowSubmit}
                                className="k-button"
                            >
                                <span className="k-icon k-i-save" /> &nbsp; {t("Global_Button_Text_Save")}
                            </button>
                        </div>) : (< span />)}
                    </FormElement>)}
            />
        </div>
    );
}
